import './kendo.core.js';

const __meta__ = {
    id: "valueMapper.chunk",
    name: "ValueMapperChunk",
    category: "web",
    description: "A reusable outputed chunk of code",
    depends: ['core'],
    hidden: true,
    chunk: true
};



let $ = kendo.jQuery;

function valueMapperOptions(options, value, callback) {
    return {
        value: (options.selectable === "multiple" || options.checkboxes) ? value : value[0],
        success: function(response) {
            callback(response);
        }
    };
}

export { valueMapperOptions as v };
export { __meta__ };